import React from 'react';
import '../styles/Projects.css';

const Projects = () => {
  const projectsData = [
    {
      id: 1,
      title: "Food Cutting Game On AWS",
      description: "This project is a DevOps implementation using React, GitHub Actions, AWS ECR, AWS ECS, and AWS CloudWatch...",
      imageUrl: require("../images/food.jpg"),
      link: "https://github.com/mihirishanika/food_cutting.git"
    },
    {
      id: 2,
      title: "DevOps Project using Jenkins & Docker on Ubuntu",
      description: "This project is a CI/CD pipeline that automates the process of building, testing and deploying application using Jenkings, Docker Hub, Docker and Ubuntu...",
      imageUrl: require("../images/cicd.jpeg"),
      link: "https://www.linkedin.com/posts/mihirishanika_devops-cicd-docker-activity-7343904144006479873-LZBf?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEdpPCMBSpXMmmxuSHTZXZhhnFEGTWaLurU"
    },
    {
      id: 3,
      title: "Bus Information Platform",
      description: "This project is a User Based Bus Information Platform using AWS S3, AWS DynamoDB, AWS Cognito, react.js and Node.js...",
      imageUrl: require("../images/businformation.jpg"),
      link: "https://github.com/mihirishanika/Bus-information-platform.git"
    },
    {
      id: 4,
      title: "DevOps capstone project",
      description: "This is the final project of IBM DevOps and Software Engineering Professional Certificate...",
      imageUrl: require("../images/capstone.png"),
      link: "https://github.com/mihirishanika/Building-an-Image-Caption-Generator-using-CNN-LSTM-from-Scratch-_DeepLearningProject.git"
    },
    {
      id: 5,
      title: "Fully Functional Login and Signup Pages",
      description: "This is a secure and user-friendly authentication system using React, Express and Node...",
      imageUrl: require("../images/login_signup.jpg"),
      link: "https://github.com/mihirishanika/SpiritX_CripticHackers_01.git"
    },
    {
      id: 6,
      title: "Embedded Public Transport Payment System",
      description: "This project is an Embedded System for Public Transportation (Train) Payments using C, ESP32 and RFID technology...",
      imageUrl: require("../images/rail_go.jpg"),
      link: "https://github.com/oshadapramod/SmartRailwayPayment.git"
    }
  ];

  const ongoingProjects = [
    {
      id: 7,
      title: "Blockchain-Based Electronic Voting System",
      description: "This project proposes a secure, transparent, and scalable Blockchain-Based Electronic Voting System using ZKP, Sharding, SoulBound NFTs and Hybrid Blockchain Architecture...",
      imageUrl: require("../images/e_voting.png"),
      link: "https://github.com/mihirishanika/blockchain-based-E-voting-system.git"
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="section-title">
        <h2>Projects</h2>
        <div className="section-title-line"></div>
      </div>

      {/* Completed */}
      <h3 className="projects-subtitle">✅ Completed Projects</h3>
      <div className="projects-grid">
        {projectsData.map((project) => (
          <div key={project.id} className="project-card">
            <a href={project.link} target="_blank" rel="noopener noreferrer">
              <img src={project.imageUrl} alt={project.title} className="project-image" />
              <div className="overlay">
                <h4>{project.title}</h4>
                <p>{project.description}</p>
              </div>
            </a>
          </div>
        ))}
      </div>

      {/* Ongoing */}
      <h3 className="projects-subtitle">🚧 Ongoing Projects</h3>
      <div className="projects-grid">
        {ongoingProjects.map((project) => (
          <div key={project.id} className="project-card">
            <a href={project.link} target="_blank" rel="noopener noreferrer">
              <img src={project.imageUrl} alt={project.title} className="project-image" />
              <div className="overlay">
                <h4>{project.title}</h4>
                <p>{project.description}</p>
              </div>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
